/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { TextField } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratingsmanager/configuration/ratingsgeneralsection/ratingscountlabel/ratingscountlabel_styles';



/* ========== ~~~~~~~~~~ ADD-ON RATINGS COUNTER LABEL ~~~~~~~~~~ ========== */
const RatingsCountLabel = props => {
    const {zero, one, multiple} = props.data;
    return (
        <div className={`ratingscountlabel ${props.classes.ratingscountlabel} section`}>
            <div className={`sectioncontent`}>
                <div className={'counterlabelfields fields'}>
                    {/*<div className={'fielditem'}>*/}
                    {/*    <TextField*/}
                    {/*        name={'ratingsLabel'}*/}
                    {/*        label={'Zero ratings'}*/}
                    {/*        type={'text'}*/}
                    {/*        placeholder={'No Ratings'}*/}
                    {/*        value={zero.value}*/}
                    {/*        valid={zero.valid}*/}
                    {/*        handleChange={e => zero.updateValue(e.target.value)}*/}
                    {/*        handleBlur={zero.updateValid}*/}
                    {/*        required={true}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <div className={'fielditem'}>
                        <TextField
                            name={'ratingsLabel'}
                            label={'One rating'}
                            type={'text'}
                            placeholder={'1 Rating'}
                            value={one.value}
                            valid={one.valid}
                            handleChange={e => one.updateValue(e.target.value)}
                            handleBlur={one.updateValid}
                            required={true}
                        />
                    </div>
                    <div className={'fielditem'}>
                        <TextField
                            name={'ratingsLabel'}
                            label={'Multiple ratings'}
                            type={'text'}
                            placeholder={'{count} Ratings'}
                            value={multiple.value}
                            valid={multiple.valid}
                            handleChange={e => multiple.updateValue(e.target.value)}
                            handleBlur={multiple.updateValid}
                            required={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RatingsCountLabel);
